import { useMutation } from "@apollo/client/react";
// Centralized lodash imports - much cleaner!
import { toLower } from '@/utils/lodash'
import {
  CHECK_SIGN_UP,
  SIGN_UP,
} from '../housefolios-components/CreateAccount/CreateAccountCard/mutations'

export const useSignupMutation = (userInput) => {
  const [checkSignup, { error: signUpError }] = useMutation(
    CHECK_SIGN_UP,
    {
      variables: {
        userInput: {
          email: toLower(userInput.email),
        },
      },
    },
  )

  const [signUp] = useMutation(SIGN_UP, {
    variables: {
      userInput,
    },
  })

  return { checkSignup, signUp, signUpError }
}
